import { z } from 'zod';

export const PerceptionMirrorDto = z.object({
  enabled: z.boolean(),
  seenAsMe: z.array(z.object({ slug: z.string() })),
  valuedByMe: z.array(z.object({ slug: z.string() })),
  narrative: z.string().nullable(),
  emptyState: z.boolean(),
});
export type PerceptionMirrorDto = z.infer<typeof PerceptionMirrorDto>;
